export default {
  userMgment: {
    userOper: {
      title: 'User List',
      userId: 'User ID',
      accountNo: 'Account',
      citizenship: 'Nationality',
      firstName: 'First Name',
      fullName: 'Full Name',
      lastName: 'Last Name',
      gender: 'Gender',
      mailBox: 'Email',
      middleName: 'Middle Name',
      mobileNumber: 'Phone',
      nickName: 'Nickname',
      phoneAreaCode: 'Area Code',
      groupId: 'Group ID',
      orgId: 'Organization ID',
      password: 'Password',
      confirmPassword: 'Confrim Password',
      userType: 'User Type'
    },
    roleOper: {
      title: 'Role List',
      roleId: 'Role ID',
      roleName: 'Role Name',
      roleNameEn: 'Role English Name',
      roleNameZh: 'Role Chinese Name',
      roleDesc: 'Role Description',
      adminFlag: 'Admin',
      defaultFlag: 'Default Role',
      enableFlag: 'Available'
    },
    menuOper: {
      title: 'Menu List',
      btnTitle: 'Add the toppest node',
      dataflagItem0: 'Yes',
      dataflagItem1: 'No',
      isOpenItem0: 'Yes',
      isOpenItem1: 'No',
      isMenu: 'Is it a menu',
      isOpen: 'Can be opened',
      levels: 'Menu Levels',
      menuCode: 'Menu Code',
      menuDesc: 'Menu Description',
      menuIcon: 'Menu Icon',
      id: 'Menu ID',
      menuNameEn: 'Menu English Name',
      menuNameZh: 'Menu Chinese Name',
      menuPcode: 'Menu Parent Code',
      menuPcodes: 'Menu Full Path Code',
      menuUrl: 'Menu URL',
      moduleId: 'Menu Name',
      orderNum: 'Menu Order'
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/authority/lang/en.js